import React from 'react';
import { Grid, TextField, Autocomplete } from '@mui/material';

class FormFields extends React.Component {
    render() {
        const { form, updateFormState, placesArray, inputClass, labelClass, muiInputSx } = this.props;

        return (
            <>
                <Grid item xs={6}>
                    <label className={labelClass}>Začiatok</label>
                    <Autocomplete
                        disablePortal
                        options={placesArray}
                        sx={muiInputSx}
                        renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Miesto štartu..." />}
                        onInputChange={(event, value, reason) => {
                            if (reason === 'input') {
                                updateFormState(value, 'start_place');
                            }
                        }}
                        onChange={(event, option, reason) => {
                            if (reason === 'selectOption') {
                                updateFormState(option.label, 'start_place');
                            }
                        }
                        }
                        freeSolo
                        value={form.start_place}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6}>
                    <label className={labelClass}>Koniec</label>
                    <Autocomplete
                        disablePortal
                        options={placesArray}
                        sx={muiInputSx}
                        renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Miesto cieľa..." />}
                        onInputChange={(event, value, reason) => {
                            if (reason === 'input') {
                                updateFormState(value, 'end_place');
                            }
                        }}
                        onChange={(event, option, reason) => {
                            if (reason === 'selectOption') {
                                updateFormState(option.label, 'end_place');
                            }
                        }
                        }
                        freeSolo
                        value={form.end_place}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6}>
                    <label className={labelClass}>Počet kanoe min</label>
                    <input
                        type="number"
                        name="kanoe_count_info_min"
                        className={inputClass}
                        value={form.kanoe_count_info_min}
                        onChange={(e) => updateFormState(e.target.value, e.target.name)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <label className={labelClass}>Počet kanoe max</label>
                    <input
                        type="number"
                        name="kanoe_count_info_max"
                        className={inputClass}
                        value={form.kanoe_count_info_max}
                        onChange={(e) => updateFormState(e.target.value, e.target.name)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <label className={labelClass}>Počet katamaránov</label>
                    <input
                        type="number"
                        name="katamaran_count_info"
                        className={inputClass}
                        value={form.katamaran_count_info}
                        onChange={(e) => updateFormState(e.target.value, e.target.name)}
                    />
                </Grid>
            </>
        );
    }
}

export default FormFields;
